<template>
	<div class="help">
	<section class="banner_area">
    <div class="banner_inner d-flex align-items-center">
      <div class="overlay bg-parallax" data-stellar-ratio="0.9" data-stellar-vertical-offset="0" data-background=""></div>
      <div class="container">
         <div class="banner_content text-left">
            <div class="page_link">
               <router-link to="/"><a>Home</a></router-link>
               <router-link to="/help"><a>Help</a></router-link>
            </div>
            <h2 style="color: black;">Help</h2><br><br>
            <h3>Explore by product</h3><br>
            <div class="row">
              <div class="col-sm-3">
                <div class="box">
                  SMART BELL
                </div>
              </div>
              <div class="col-sm-3">
                <div class="box">
                  BEE APPS
                </div>
              </div>
              <div class="col-sm-3">
                <div class="box">
                  PASSWORD MANAGER
                </div>
              </div>
              <div class="col-sm-3">
                <div class="box">
                  MAILER API
                </div>
              </div>
            </div>
         </div>
      </div>
    </div>
    </section>
  <Footer/>

  </div>
</template>

<script>
// @ is an alias to /src
import Footer from "@/components/Footer.vue";

export default {
  name: "Home",
  components: {
    Footer
  }
};
</script>

<style scoped>
  .box {
    background-color: #fff;
    border: 2px solid #000;
    border-radius: 5px;
    padding: 15px;
    text-align: center;
    color: #000;
  }
</style>